import { createContext, useContext, useReducer } from 'react';
import { BudgetProgramSearchState, BudgetProgramSearchReducer, ACTION_TYPES } from './budget-program-search-reducer';

const BudgetProgramSearchContext = createContext<BudgetProgramSearchState | undefined>(undefined);
const BudgetProgramSearchDispatchContext = createContext({} as any);

const BudgetProgramSearchProvider = ({ children }: { children: React.ReactNode }) => {
    const initialState: BudgetProgramSearchState = {
        parameters: {},
        budgetUnits: [],
        searchTrigger: 0,
    };
    const [state, dispatch] = useReducer(BudgetProgramSearchReducer, initialState);
    return (
        <BudgetProgramSearchContext.Provider value={state}>
            <BudgetProgramSearchDispatchContext.Provider value={dispatch}>
                {children}
            </BudgetProgramSearchDispatchContext.Provider>
        </BudgetProgramSearchContext.Provider>
    );
};

const useBudgetProgramSearchState = () => {
    const context = useContext(BudgetProgramSearchContext);
    if (!context) throw new Error('useBudgetProgramSearchState must be used within BudgetProgramSearchProvider');
    return context;
};

const useBudgetProgramSearchDispatch = () => {
    const context = useContext(BudgetProgramSearchDispatchContext);
    if (!context) throw new Error('useBudgetProgramSearchDispatch must be used within BudgetProgramSearchProvider');
    return context;
};

export { BudgetProgramSearchProvider, useBudgetProgramSearchState, useBudgetProgramSearchDispatch, ACTION_TYPES };
